import { Modelable } from "../../../entities/src/modelable";
import { ITestSuite } from "../../../entities/src/testSuite";

export class TestSuite implements Modelable<ITestSuite> {
    constructor(public data: ITestSuite) {}
}
